const NewsContent = [
    {
      publisher: "BLG",
      time: "10:25",
      headline: "Together 15 years",
      content: "In a quaint town nestled within the picturesque landscapes of Slovakia, a group of excited faces gathered around a sign that read: 'We are very happy to announce our new office in Slovakia.' Laughter echoed as dreams of expansion and opportunity danced in their minds, marking the beginning of a new chapter filled with promise and adventure."
    },
    {
      publisher: "Milsped",
      time: "10:43",
      headline: "Engine break down",
      content: "Panic rippled through the team as they realized the gravity of the situation. With deadlines looming and clients awaiting their goods, failure was not an option. Frantically, mechanics swarmed around the malfunctioning trucks, wrenches clinking against metal as they attempted to rectify the issues. Time was slipping away like sand through their fingers."
    },
    {
      publisher: "Milsped",
      time: "13:55",
      headline: "Last car of the month",
      content: "We just shipped the last car of the month April."
    },
  ];
  
  export default NewsContent;
  